import { ChevronRight, RemoveRedEye, Twitter } from '@mui/icons-material';
import { Avatar, Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Chip, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import '../../styles/scrollingBanner.css';

const ScrollingBanner = ({ images, speed = 5000, direction }) => {
    return (
        <div className="content">
            <div className="wrapper h-full">
                {
                    new Array(3).fill('').map(() => 
                        <section className={`${direction === 'forward'? 'section-forward': 'section-backward'}`} style={{ "--speed": `${speed}ms` }}>
                            {images.map(({ id, image }) => (
                                <div className='px-3' key={id}>
                                    <div className="image rounded-2xl h-full w-72 lg:w-80 overflow-hidden shadow-lg bg-white bg-opacity-10 hover:bg-[#C3AD60] hover:text-white cursor-pointer">
                                        <Box
                                            sx={{ color: 'secondary.main', backgroundColor: 'primary.lightYellow' }}
                                            className='relative flex flex-col overflow-hidden h-full'
                                        >
                                            <Box className='absolute top-0 p-2'>
                                                <Chip label={<><RemoveRedEye /> 23</>} sx={{ color: 'primary.light' }} variant='outlined' clickable />
                                            </Box>
                                            <Box className='h-72 object-cover'>
                                                <img className='h-full w-full' src={image} alt={image} />
                                            </Box>
                                            <Stack className='p-3' gap={1}>
                                                <Typography variant='h6' sx={{ margin: 0, padding: 0 }}>
                                                    Do business really get free website and a...
                                                </Typography>
                                                <Stack direction='row' gap={1} justifyContent='space-between' alignItems='center'>
                                                    <Stack gap={.5}>
                                                        <Stack direction='row' gap={1} alignItems='center' className='text-gray-600'>
                                                            <Typography variant='caption'>
                                                                The
                                                            </Typography>
                                                            <Avatar
                                                                alt='Twitter User' src={image}
                                                                sx={{
                                                                    width: {
                                                                        xs: 20,
                                                                        md: 25
                                                                    },
                                                                    height: {
                                                                        xs: 20,
                                                                        md: 25
                                                                    }
                                                                }}
                                                            />
                                                            <Typography variant='caption'>
                                                                Kene Nnakwue
                                                            </Typography>
                                                        </Stack>
                                                        <Typography variant='caption' className='text-gray-600'>03:32 PM Friday 31</Typography>
                                                    </Stack>
                                                    <Button variant='filled' size='small'
                                                        sx={{ color: 'primary.yorisWhite', backgroundColor: 'primary.darkYellow', borderRadius: '20px', textTransform: 'none' }}
                                                    >Read More</Button>
                                                </Stack>
                                            </Stack>
                                        </Box>
                                    </div>
                                </div>
                            ))}
                        </section>
                    )
                }
            </div>
        </div>
    );
};

export default ScrollingBanner;